<template>
  <dl class="SelectItem">
    <dt class="select-item__filter-container">
      <input
        class="select-item__filter-box"
        type="text"
        placeholder="例:2001（※数字のみで検索可）"
        v-model="filterText"
      />
    </dt>
    <dd class="select-item__list-container">
      <transition-group tag="ul" class="select-item__list"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        @enter-cancelled="beforeEnter"
      >
        <li
          class="select-item__item"
          v-for="({sig, key, title, name}, index) in showList"
          :data-index="index"
          :key="sig"
        >
          <router-link
            v-if="sig !== '__noItem__'"
            class="select-item__link"
            :to="{path: key}"
          >{{ title }}<span class="name"
            >{{ name }}</span></router-link
          >
          <span v-else class="select-item__no-item">No Item</span>
        </li>
      </transition-group>
    </dd>
  </dl>
</template>

<script>

export default {
  name: 'SelectItem',
  data() {
    return {
      filterText: ''
    }
  },
  computed: {
    z2hText () {
      return this.filterText.replace(
        /[Ａ-Ｚａ-ｚ０-９]/g,
        (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      ).toUpperCase()
    },
    showList () {
      if (this.z2hText === '') return [{ sig: '__noItem__' }]
      let minIndex;
      const uniq = new Set()
      const hitList = this.indexList
        .reduce(
          (list, data) => {
            const hitIndex = data.sig.indexOf(this.z2hText)
            if (hitIndex > -1) {
              list.push({...data, at: hitIndex})
              if (!minIndex || minIndex > hitIndex) minIndex = hitIndex
            }
            return list
          }, [])
          .filter(({at}) => at === minIndex )
       return hitList.length !== 0
        ? hitList.filter(
            ({title}) =>
              !uniq.has(title) && Boolean(uniq.add(title))
          )
        : [{ sig: '__noItem__' }]
    },
    indexList () {
      return this.$store.state.indexList
    }
  },
  methods: {
    // トランジション開始でインデックス*100ms分のディレイを付与
    beforeEnter(el) {
      const index = parseInt(el.dataset.index, 10)
      el.style.transitionDelay = index > 20 ? '' : 100 * index + 'ms'
    },
    // トランジション完了またはキャンセルでディレイを削除
    afterEnter(el) {
      el.style.transitionDelay = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.SelectItem {
  background-color: #fff;
}
.select-item__filter-container {
  padding: 16px 8px;
  border-bottom: 2px solid var(--accent-color);
}
.select-item__filter-box {
  width: 90%;
  max-width: 15em;
  color: #777;
  font-size: 16px;
}
/* .select-item__list-container {
  font-size: 16px;
} */
.select-item__list {
  font-size: 32px;
  /* text-align: left; */
}
.select-item__item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  width: 100%;
  /* height: 56px; */
  background-color: #fff;
  border-bottom: 1px solid #555;
  white-space: pre-wrap;
}
.select-item__link {
  display: block;
  color: #aaa;
  text-decoration: none;
}
.select-item__link .name {
  display: block;
  font-size: 0.6em;
}
.select-item__no-item {
  color: #ddd;
}
/* トランジション用スタイル */
.v-enter-active, .v-leave-active, .v-move {
  transition: opacity 1s, transform 1s;
}
.v-leave-active {
  position: absolute;
}
.v-enter {
  opacity: 0;
  transform: translateY(-20px);
}
.v-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>



// WEBPACK FOOTER //
// src/components/SelectItem.vue